import * as Action from "../action/load_regulation_obj.action";

const initState = {
    devicesList: []
}


const loadRegulationReducer = (state = initState, action) => {
    switch (action.type) {
        case Action.INIT_LOAD_OBJECT_DEVICES: // 初始化选中设备列表
            return {
                devicesList: action.devicesList
            };
        case Action.ADD_LOAD_OBJECT_DEVICES: // 添加选中设备列表
            let addList = [...state.devicesList, ...action.devicesList]
            let obj = {};
            // 数组去重
            addList = addList.reduce((cur,next) => {
                if(!obj[next.id]){
                    obj[next.id] = true;
                    cur.push(next);
                }
                return cur;
            },[])
            return {
                devicesList: addList
            };
        case Action.DELETE_LOAD_OBJECT_DEVICES: // 删除选中设备列表
            const deleteList = action.devicesList.map(item => item.id);
            return {
                devicesList: state.devicesList.filter(item => deleteList.indexOf(item.id) == -1)
            };
        default: return {...state}
    }
}

export default loadRegulationReducer;
